module.exports = __webpack_public_path__ + "static/media/default.e84e68e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/default.png
// module id = 1902
// module chunks = 6